import { FormVariant } from "@comparaonline/car-dealer-chile";

export enum FormStatus {
  Success = "success",
  Fail = "fail"
}

export enum QueryParams {
  CarDealerName = "carDealerName",
  CarDealerAgentId = "carDealerAgentId"
}

export const FormVariantURLMapper: Record<string, string | FormVariant> = {
  [FormVariant.ContactClient]: "contact",
  [FormVariant.ContactClientOrRedirectQuoteForm]: "contactOrRedirect",
  [FormVariant.ImmediateRedirectQuoteForm]: "immediateRedirect",
  [FormVariant.RedirectQuoteForm]: "redirect",
  contact: FormVariant.ContactClient,
  contactOrRedirect: FormVariant.ContactClientOrRedirectQuoteForm,
  immediateRedirect: FormVariant.ImmediateRedirectQuoteForm,
  redirect: FormVariant.RedirectQuoteForm
};

export const CarDealerCollection = "car-dealer-forms";
